import React from 'react';
import { useEffect, useState } from 'react'
import {
  SDrawerOrModal,
} from 'shj-components'
import { Form, Input, Select, InputNumber, Typography, Table, Popconfirm, Button, message } from 'antd';
import {
  addNewContractTemplateExtend,
  getContractTemplateExtendList,
  updateNewContractTemplateExtend,
  deleteNewContractTemplateExtend,
  getFilterTypeEnum,
  getExtensionItemTypeEnum,
  getExtensionFieldTypeEnum
} from '@/services/goods.ts';
import styles from './index.module.less'

interface Item {
  id: string;
  lableName: string;
  defaultValue: number | string;
  requiredFlag: string;
  engName: string;
  category: string;
  type: string;
  fieldRange: string;
  dataFillField: string;
  calculateFlag: string;
  calculateForular: string;
  filterType: string;
  filterValue: string;
}

const EditableCell = ({
  editing,
  dataIndex,
  textIndex,
  title,
  inputType,
  record,
  index,
  isSelect,
  options,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input disabled={dataIndex === 'engName'} />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: (dataIndex === 'lableName') ? true : false,
              message: `请输入${title}!`,
            },
          ]}
        >
          {isSelect ? <Select allowClear style={{ width: '100%'}} options={options} /> : inputNode}
        </Form.Item>
      ) : (
        <>
          {isSelect ? <span>{ record[textIndex] }</span> : children}
        </>
      )}
    </td>
  );
};

export default function ExtraModal ({ editId = '', open = false, onClose = () => {} })  {
  const [form] = Form.useForm();
  const [extraData, setExtraData] = useState([]);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [dictionaryData, setDictionaryData] = useState({
    filterType: [], // 过滤类型
    extensionFieldType: [], //扩展字段类型
    extensionItemType: [], // 扩展字段分类
  });
  const [editingKey, setEditingKey] = useState('');
  const [modalLoading, setModalLoading] = useState(false);

  const isEditing = (record) => { // 两种情况。一种是编辑，一种是新增，新增没有id
    if (record.id) {
      return record.id === editingKey;
    } else {
      return !record.id && (String(extraData.length - 1) === editingKey);
    }
  }

  useEffect(() => {
    fetchDictionaryData();
    fetchList();
  }, []);

  const fetchDictionaryData = async () => {
    try {
      const filterTypeRes: any = await getFilterTypeEnum();
      const extensionItemTypeRes: any = await getExtensionItemTypeEnum();
      const extensionFieldTypeRes: any = await getExtensionFieldTypeEnum();
      const dicDataMap: any = {};
      if (filterTypeRes?.length) {
        dicDataMap['filterType'] = filterTypeRes.map(contract => ({
          label: contract?.description,
          value: contract?.key,
        }));
      }
      if (extensionItemTypeRes?.length) {
        dicDataMap['extensionItemType'] = extensionItemTypeRes.map(budget => ({
          label: budget?.description,
          value: budget?.key,
        }));
      }
      if (extensionFieldTypeRes?.length) {
        dicDataMap['extensionFieldType'] = extensionFieldTypeRes.map(budget => ({
          label: budget?.description,
          value: budget?.key,
        }));
      }
      const booleanOption = [{
        value: true,
        label: '是',
      }, {
        value: false,
        label: '否'
      }]
      dicDataMap['requiredFlag'] = booleanOption;
      dicDataMap['calculateFlag'] = booleanOption;
      setDictionaryData(dicDataMap);
    } catch (err) {
      console.log(err)
    }
  }

  const fetchList = async (page = 1, pageSize = 10) => {
    try {
      setCurrentPage(page);
      const res: any = await getContractTemplateExtendList({
        printTemplateId: editId,
        pageId: page,
        pageSize,
      })
      if (res?.list) {
        // 处理删除每页最后一个数据的问题
        if (!res?.list?.length && Number(res.maxPageId) < Number(res.currentPageId) && res.count !== '0' && page > 1 ) {
          fetchList(page - 1);
          return;
        }
        setCount(Number(res?.count));
        // 处理下自动取数布尔和必填布尔的回显
        const newList = res.list?.length ? res.list.map((item: any) => ({
          ...item,
          calculateFlagText: item.calculateFlag ? '是' : '否',
          requiredFlagText: item.requiredFlag ? '是' : '否',
        })) : [];
        setExtraData(newList);
      }
    } catch(err) {
      console.log(err)
    }
  }

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.id);
  };

  const cancel = (id: any, index: number) => {
    setEditingKey('');
    if (!id) {
      const newData = [...extraData];
      newData.splice(index, 1)
      setExtraData(newData);
    }
    form.resetFields();
  };

  const save = async (id) => {
    try {
      const row = await form.validateFields();
      const newData: any = [...extraData];
      const index = newData.findIndex((item) => id === item.id);
      if (id && index > -1) { // 编辑
        setModalLoading(true);
        await updateNewContractTemplateExtend({
          ...newData[index],
          ...row,
          id,
          printTemplateId: editId 
        })
        await fetchList(currentPage); // 编辑保持页码不变
        setModalLoading(false);
        setEditingKey('');
      } else { // 新增
        setModalLoading(true);
        await addNewContractTemplateExtend({
          ...row,
          printTemplateId: editId
        });
        await fetchList();
        setModalLoading(false);
        setCurrentPage(1); // 新增回到第一页
        setEditingKey('');
      }
      form.resetFields();
    } catch (errInfo) {
      setModalLoading(false);
      console.log('Validate Failed:', errInfo);
    }
  };

  const handleDelete = async (record: any) => {
    try {
      const res: any = await deleteNewContractTemplateExtend(record.id);
      if (res.errorCode === 0) {
        message.success('删除成功');
        await fetchList(currentPage);
      } else {
        message.error('删除失败');
      }
    } catch (err) {
      message.error('删除失败')
      console.log(err);
    }
  }

  const columns = [
    {
      title: '字段名称',
      dataIndex: 'lableName',
      width: 100,
      editable: true,
    },
    {
      title: '默认值',
      dataIndex: 'defaultValue',
      width: 80,
      editable: true,
    },
    {
      title: '是否必填',
      dataIndex: 'requiredFlag',
      optionIndex: 'requiredFlag',
      textIndex: 'requiredFlagText',
      width: 80,
      editable: true,
      isSelect: true,
    },
    {
      title: '英文字母',
      dataIndex: 'engName',
      width: 120,
      editable: true,
    },
    {
      title: '字段分类',
      dataIndex: 'itemType',
      optionIndex: 'extensionItemType',
      textIndex: 'itemTypeName',
      width: 180,
      editable: true,
      isSelect: true,
    },
    {
      title: '字段类型',
      dataIndex: 'fieldType', // form字段值
      optionIndex: 'extensionFieldType', // 字典字段值
      textIndex: 'fieldTypeName', // 回显字段值
      width: 180,
      editable: true,
      isSelect: true,
    },
    {
      title: '字段范围',
      dataIndex: 'fieldRange',
      width: 150,
      editable: true,
    },
    {
      title: '补充字段',
      dataIndex: 'dataFillField',
      width: 150,
      editable: true,
    },
    {
      title: '自动取数',
      dataIndex: 'calculateFlag',
      optionIndex: 'calculateFlag',
      textIndex: 'calculateFlagText',
      width: 80,
      editable: true,
      isSelect: true,
    },
    {
      title: '取数计算式',
      dataIndex: 'calculateForular',
      editable: true,
      width: 150,
    },
    {
      title: '过滤类型',
      dataIndex: 'filterType',
      optionIndex: 'filterType',
      textIndex: 'filterTypeName',
      width: 180,
      editable: true,
      isSelect: true,
    },
    {
      title: '过滤值',
      dataIndex: 'filterValue',
      width: 80,
      editable: true,
    },
    {
      title: '操作',
      dataIndex: 'operation',
      fixed: 'right',
      width: 120,
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.id)}
              style={{
                marginRight: 8,
              }}
            >
              保存
            </Typography.Link>
            <Popconfirm title="确定要取消吗?" onConfirm={() => cancel(record.id, index)}>
              <a>取消</a>
            </Popconfirm>
          </span>
        ) : (
          <>
            <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
              编辑
            </Typography.Link>
            <Typography.Link style={{ marginLeft: 8, color: 'red' }} disabled={editingKey !== ''} onClick={() => handleDelete(record)}>
              删除
            </Typography.Link>
          </>          
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        textIndex: col.textIndex,
        title: col.title,
        isSelect: col.isSelect,
        options: col.isSelect ? dictionaryData[col.optionIndex] : [],
        editing: isEditing(record),
      }),
    };
  });

  const handleAddNewExtraInfo = () => {
    if (editingKey) {
      return;
    }
    const newData: any = [...extraData];
    newData.unshift({
      id: '',
      lableName: '',
      defaultValue: '',
      requiredFlag: '',
      engName: '',
      category: '',
      type: '',
      fieldRange: '',
      dataFillField: '',
      calculateFlag: '',
      calculateForular: '',
      filterType: '',
      filterValue: '',
    })
    setExtraData(() => {
      setEditingKey(String(extraData.length));
      return newData
    });
  }

  return (
    <div className={styles.contractExtraModal}>
      <SDrawerOrModal
        mode="drawer"
        open={open}
        loading={modalLoading}
        onCancel={() => onClose()}
        width="75%"
        isHideCancelBtn={true}
        okBtnDisabled={true}
        antdProps={{
          footer: null
        }}
      >
        <Button type='primary' style={{ marginBottom: 10 }} onClick={handleAddNewExtraInfo}>新增</Button>
        <Form form={form} component={false}>
          <Table
            size={'middle'}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            scroll={{
              x: 1500,
            }}
            bordered
            dataSource={extraData}
            columns={mergedColumns}
            pagination={{
              total: count,
              current: currentPage,
              pageSize: 10,
              onChange: fetchList,
            }}
          />
        </Form>
      </SDrawerOrModal>
    </div>
  )
}
